import './welcome.css'
import checkin from '../../assets/Entrance.png'
import { useLanguage } from '../../context/LanguageContext'

const Welcome = () => {
  const { language, startSession, goNext, allTranslations } = useLanguage()
  const t = allTranslations[language] || allTranslations['en']

  const handleCheckin = () => {
    startSession()
    goNext()
  }

  return (
    <div className="viGuard__header section__padding" id="home">
      <div className="viGuard__header-content">
        <h1 className="gradient__text">{t.welcome_title}</h1>
        <p>
          {t.welcome_description}{' '}
          <a href='https://www.viguard.de/datenschutz/'>{t.privacy_policy}</a>
        </p>

        <div className="viGuard__header-content__input">
          <button type="button" onClick={handleCheckin}>
            {t.pre_checkin_button}
            <img src={checkin} alt="checkIn" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default Welcome
